/**
 * @generated SignedSource<<ce2635b2feb9385fa898db4dc2f62fbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "stationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lon",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bikesAvailable",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spacesAvailable",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "networks",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CityBikePopupQuery",
    "selections": [
      {
        "alias": "station",
        "args": (v1/*: any*/),
        "concreteType": "BikeRentalStation",
        "kind": "LinkedField",
        "name": "bikeRentalStation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CityBikePopupQuery",
    "selections": [
      {
        "alias": "station",
        "args": (v1/*: any*/),
        "concreteType": "BikeRentalStation",
        "kind": "LinkedField",
        "name": "bikeRentalStation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d8b8644cc2dca74e23d7705bbd4046c",
    "id": null,
    "metadata": {},
    "name": "CityBikePopupQuery",
    "operationKind": "query",
    "text": "query CityBikePopupQuery(\n  $stationId: String!\n) {\n  station: bikeRentalStation(id: $stationId) {\n    stationId\n    name\n    lat\n    lon\n    bikesAvailable\n    spacesAvailable\n    state\n    networks\n    id\n  }\n}\n"
  }
};
})();

node.hash = "bd78420d22e160fbf1b4af972a413d0a";

module.exports = node;
